(function () {
  'use strict';

  var SKIP_SELECTORS = [
    'select[name="id"]',
    'select.hidden',
    'select.noreplace',
    'select[data-no-custom]'
  ];

  function shouldSkip(sel) {
    for (var i = 0; i < SKIP_SELECTORS.length; i++) {
      if (sel.matches(SKIP_SELECTORS[i])) return true;
    }
    if (sel.closest('.zipifypages-section')) return true;
    if (sel.offsetParent === null && !sel.closest('dialog') && !sel.closest('[hidden]')) return true;
    return false;
  }

  function createCustomSelect(nativeSelect) {
    if (nativeSelect.dataset.customSelectInit === 'true') return;
    if (shouldSkip(nativeSelect)) return;
    nativeSelect.dataset.customSelectInit = 'true';

    var wrapper = document.createElement('div');
    wrapper.className = 'custom-select';
    wrapper.setAttribute('role', 'listbox');
    wrapper.setAttribute('tabindex', '0');

    var trigger = document.createElement('div');
    trigger.className = 'custom-select__trigger';
    trigger.setAttribute('aria-haspopup', 'listbox');
    trigger.setAttribute('aria-expanded', 'false');

    var triggerText = document.createElement('span');
    triggerText.className = 'custom-select__trigger-text';

    var arrow = document.createElement('span');
    arrow.className = 'custom-select__arrow';
    arrow.innerHTML = '<svg viewBox="0 0 10 6"><polyline points="1 1 5 5 9 1"></polyline></svg>';

    trigger.appendChild(triggerText);
    trigger.appendChild(arrow);

    var dropdown = document.createElement('div');
    dropdown.className = 'custom-select__dropdown';
    dropdown.setAttribute('role', 'listbox');

    wrapper.appendChild(trigger);
    wrapper.appendChild(dropdown);

    nativeSelect.parentNode.insertBefore(wrapper, nativeSelect);
    wrapper.appendChild(nativeSelect);
    nativeSelect.classList.add('custom-select-hidden');

    var parentWrapper = wrapper.parentNode;
    if (parentWrapper) {
      var caretIcons = parentWrapper.querySelectorAll(':scope > svg, :scope > .icon, :scope > .icon-caret');
      for (var ci = 0; ci < caretIcons.length; ci++) {
        caretIcons[ci].style.display = 'none';
      }
      if (parentWrapper.classList.contains('variant-option__select-wrapper')) {
        parentWrapper.style.overflow = 'visible';
      }
    }

    var focusedIndex = -1;

    function buildOptions() {
      dropdown.innerHTML = '';
      var options = nativeSelect.options;
      for (var i = 0; i < options.length; i++) {
        var opt = options[i];
        var div = document.createElement('div');
        div.className = 'custom-select__option';
        div.setAttribute('role', 'option');
        div.setAttribute('data-value', opt.value);
        div.setAttribute('data-index', i);
        div.textContent = opt.textContent.trim();
        if (opt.selected) {
          div.classList.add('custom-select__option--selected');
          div.setAttribute('aria-selected', 'true');
        }
        var isUnavailable = opt.disabled ||
          opt.textContent.toLowerCase().indexOf('unavailable') !== -1 ||
          opt.textContent.toLowerCase().indexOf('sold out') !== -1 ||
          opt.getAttribute('data-option-available') === 'false';
        if (isUnavailable) {
          div.classList.add('custom-select__option--disabled');
        }
        dropdown.appendChild(div);
      }
      syncLabel();
    }

    function syncLabel() {
      var selected = nativeSelect.options[nativeSelect.selectedIndex];
      triggerText.textContent = selected ? selected.textContent.trim() : '';
    }

    function open() {
      if (wrapper.classList.contains('custom-select--open')) return;
      closeAll();
      wrapper.classList.add('custom-select--open');
      trigger.setAttribute('aria-expanded', 'true');
      focusedIndex = nativeSelect.selectedIndex;
      updateFocus();
      scrollToFocused();
    }

    function close() {
      wrapper.classList.remove('custom-select--open');
      trigger.setAttribute('aria-expanded', 'false');
      focusedIndex = -1;
      clearFocus();
    }

    function isOpen() {
      return wrapper.classList.contains('custom-select--open');
    }

    function selectByIndex(idx) {
      if (idx < 0 || idx >= nativeSelect.options.length) return;
      if (nativeSelect.options[idx].disabled) return;
      nativeSelect.selectedIndex = idx;
      buildOptions();
      close();
      nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function updateFocus() {
      clearFocus();
      var items = dropdown.querySelectorAll('.custom-select__option');
      if (focusedIndex >= 0 && focusedIndex < items.length) {
        items[focusedIndex].classList.add('custom-select__option--focused');
      }
    }

    function clearFocus() {
      var focused = dropdown.querySelectorAll('.custom-select__option--focused');
      for (var i = 0; i < focused.length; i++) {
        focused[i].classList.remove('custom-select__option--focused');
      }
    }

    function scrollToFocused() {
      var items = dropdown.querySelectorAll('.custom-select__option');
      if (focusedIndex >= 0 && focusedIndex < items.length) {
        var item = items[focusedIndex];
        var top = item.offsetTop;
        var bottom = top + item.offsetHeight;
        if (top < dropdown.scrollTop) {
          dropdown.scrollTop = top;
        } else if (bottom > dropdown.scrollTop + dropdown.clientHeight) {
          dropdown.scrollTop = bottom - dropdown.clientHeight;
        }
      }
    }

    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (isOpen()) {
        close();
      } else {
        open();
      }
    });

    dropdown.addEventListener('click', function (e) {
      var target = e.target.closest('.custom-select__option');
      if (!target) return;
      e.stopPropagation();
      var idx = parseInt(target.getAttribute('data-index'), 10);
      selectByIndex(idx);
    });

    wrapper.addEventListener('keydown', function (e) {
      var totalOptions = nativeSelect.options.length;
      if (!totalOptions) return;

      switch (e.key) {
        case 'Enter':
        case ' ':
          e.preventDefault();
          if (isOpen()) {
            if (focusedIndex >= 0) selectByIndex(focusedIndex);
            else close();
          } else {
            open();
          }
          break;
        case 'ArrowDown':
          e.preventDefault();
          if (!isOpen()) { open(); return; }
          focusedIndex = Math.min(focusedIndex + 1, totalOptions - 1);
          updateFocus();
          scrollToFocused();
          break;
        case 'ArrowUp':
          e.preventDefault();
          if (!isOpen()) { open(); return; }
          focusedIndex = Math.max(focusedIndex - 1, 0);
          updateFocus();
          scrollToFocused();
          break;
        case 'Escape':
          if (isOpen()) {
            e.preventDefault();
            close();
          }
          break;
        case 'Tab':
          close();
          break;
      }
    });

    var nativeObserver = new MutationObserver(function () {
      buildOptions();
    });
    nativeObserver.observe(nativeSelect, { childList: true, subtree: true, attributes: true, attributeFilter: ['selected'] });

    nativeSelect.addEventListener('change', function () {
      syncLabel();
      var items = dropdown.querySelectorAll('.custom-select__option');
      for (var j = 0; j < items.length; j++) {
        items[j].classList.remove('custom-select__option--selected');
        items[j].removeAttribute('aria-selected');
      }
      var sel = dropdown.querySelector('[data-index="' + nativeSelect.selectedIndex + '"]');
      if (sel) {
        sel.classList.add('custom-select__option--selected');
        sel.setAttribute('aria-selected', 'true');
      }
    });

    buildOptions();
  }

  function closeAll(except) {
    var openDropdowns = document.querySelectorAll('.custom-select--open');
    for (var i = 0; i < openDropdowns.length; i++) {
      if (except && openDropdowns[i] === except) continue;
      openDropdowns[i].classList.remove('custom-select--open');
      var trig = openDropdowns[i].querySelector('.custom-select__trigger');
      if (trig) trig.setAttribute('aria-expanded', 'false');
    }
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest('.custom-select')) {
      closeAll();
    }
  });

  function initAll() {
    var selects = document.querySelectorAll('select:not([data-custom-select-init="true"])');
    for (var i = 0; i < selects.length; i++) {
      createCustomSelect(selects[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  var bodyObserver = new MutationObserver(function (mutations) {
    var hasNewSelects = false;
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        if (added[j].nodeType !== 1) continue;
        if (added[j].tagName === 'SELECT' || added[j].querySelector && added[j].querySelector('select')) {
          hasNewSelects = true;
          break;
        }
      }
      if (hasNewSelects) break;
    }
    if (hasNewSelects) {
      setTimeout(initAll, 50);
    }
  });
  bodyObserver.observe(document.body, { childList: true, subtree: true });

  window.customSelectRefresh = initAll;
})();
